import Button from '@/components/Button';
import Title from '@/components/Title';
import ExpandableSearch from '@/components/inputs/ExpandableSearch';
import { classes } from './utils';

export type FormsHeaderProps = {
  search: string;
  onSearch: (search: string) => void;
  onAddNew: () => void;
};

export default function FormsHeader({
  search,
  onSearch,
  onAddNew,
}: FormsHeaderProps) {
  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>
        <Title className={classes.title} size="sm">
          Forms
        </Title>
        <ExpandableSearch
          className={classes.search}
          variant="aurora"
          value={search}
          onChange={onSearch}
          onClose={() => onSearch('')}
        />
      </div>
      <Button className={classes.addButton} onClick={onAddNew}>
        Add Form
      </Button>
    </div>
  );
}
